module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/testimonials-823ebf861fa3c4c2842b1137174531a6.jpg";